const styles = theme => ({
  root: {
    display: 'flex',
    width: '100%',
  },
  formControl: { 'margin-top': theme.spacing.unit, 'margin-bottom': theme.spacing.unit },
  formLabel: { fontSize: 13.5 },
  group: {
    'flex-direction': 'row',
    '-ms-flex-direction': 'row',
  },
  checked: { color: '#2974FF !important' },
});

export default styles;



// WEBPACK FOOTER //
// ./src/containers/passengers/common/editPassenger/DateTimePickerWrapperStyles.js